export default {
    state: {
        snackbarVisible: false,
        message: "",
        timeout: 2500
    },
    show(message: string) {
        this.state.snackbarVisible = true;
        this.state.message = message
    },
    showWithTimeout(message: string, customTimeout: number) {
        this.state.snackbarVisible = true;
        this.state.message = message;
        this.state.timeout = customTimeout
    },
    dismiss() {
        this.state.snackbarVisible = false;
        this.state.message = ""
    }
}
